export default function fetchSchoolBySlink ({ to, store }) {
  if (store.state.school) return
  store.dispatch('SET_SLINK', to.params.slink)
}
